module.exports = __webpack_public_path__ + "static/media/change-password-lock.3bd482f5.svg";